/**
 * 说明:
 * http://8.142.215.242:8078/#/zh-CN/docs-dom/ImportTable
 */

const importConfig = {
  ST_ASSIGN_WAREHOUSE_STRATEGY__ST_ASSIGN_WAREHOUSE_IMPORT: {
    isAsync: true,
    isAction: true,
    tableName: 'ST_ASSIGN_WAREHOUSE_STRATEGY',
    webname: 'ST_ASSIGN_WAREHOUSE_IMPORT',
    okApi: '/api/cs/sg/v2/stAssignWarehouseStrategy/import',
    tempApi: '/api/cs/sg/v2/stAssignWarehouseStrategy/import/downloadTemp',
  },
  ST_C_GIFT_REDEMPTION_STRATEGY__ST_C_GIFT_REDEMPTION_STRATEGY_GIFT_IMPORT: {
    isAsync: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'ST_C_GIFT_REDEMPTION_STRATEGY',
    webname: 'ST_C_GIFT_REDEMPTION_STRATEGY_GIFT_IMPORT',
    okApi: '/api/cs/oc/oms/v1/stCGiftRedemptionStrategyImport',
    okParm: { objid: null, type: 'gift' },
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCGiftRedemptionStrategyGiftItemImport'
    },
  },
  ST_C_GIFT_REDEMPTION_STRATEGY__ST_C_GIFT_REDEMPTION_STRATEGY_ITEM_IMPORT: {
    isAsync: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'ST_C_GIFT_REDEMPTION_STRATEGY',
    webname: 'ST_C_GIFT_REDEMPTION_STRATEGY_ITEM_IMPORT',
    okApi: '/api/cs/oc/oms/v1/stCGiftRedemptionStrategyImport',
    okParm: { objid: null, type: 'pro' },
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCGiftRedemptionStrategyItemImport'
    },
  },
  OC_B_CLAIM_ORDER__OC_B_CLAIM_ORDER_BATCH_IMPORT_RESULT_LIST: {
    isAsync: true,
    isAction: true,
    tableName: 'OC_B_CLAIM_ORDER',
    webname: 'OC_B_CLAIM_ORDER_BATCH_IMPORT_RESULT_LIST',
    okApi: '/api/cs/oc/oms/v1/claim/batchUpdate',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'claimTemplate'
    },
  },
  SG_B_STO_OTHER_OUT__SG_B_STO_OTHER_OUT_BATCH_IMPORT: {
    // 其它出库单-头明细导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    tableName: 'SG_B_STO_OTHER_OUT',
    webname: 'SG_B_STO_OTHER_OUT_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBStoOtherOut/batchImport',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBStoOtherOutImport'
    },
  },
  SG_B_STO_IN_RESULT__SG_B_STO_IN_RESULT_BATCH_IMPORT: {
    // 逻辑入库单-批量导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    tableName: 'SG_B_STO_IN_RESULT',
    webname: 'SG_B_STO_IN_RESULT_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBStoInResult/batchImport',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBStoInResultImport'
    },
  },
  SG_B_STO_OUT_RESULT__SG_B_STO_OUT_RESULT_BATCH_IMPORT: {
    // 逻辑出库单-批量导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    tableName: 'SG_B_STO_OUT_RESULT',
    webname: 'SG_B_STO_OUT_RESULT_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBStoOutResult/batchImport',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBStoOutResultImport'
    },
  },
  SG_C_PRE_SALE_PLAN__SG_C_PRE_PLAN_ITEM_IMPORT: {
    // 预售计划单-子表【预售明细】-明细导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'SG_C_PRE_SALE_PLAN',
    webname: 'SG_C_PRE_PLAN_ITEM_IMPORT',
    okApi: '/api/cs/sg/presaleplan/itemImport',
    okParm: { objid: null, isAdd: false },
    tempParm: {
      id: () => vm.$route.params.itemId
    },
    tempApi: '/api/cs/sg/presaleplan/getImportTemplate'
  },
  SG_C_PRE_SALE_PLAN__ADD_PRE_SALE_QUANTITY_IMPORT: {
    // 预售计划单-子表【预售明细】-追加预售数量(导入)
    isAsync: true,
    rowControl: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'SG_C_PRE_SALE_PLAN',
    webname: 'ADD_PRE_SALE_QUANTITY_IMPORT',
    okApi: '/api/cs/sg/presaleplan/itemImport',
    okParm: { objid: null, isAdd: true },
    tempParm: {
      id: () => vm.$route.params.itemId
    },
    tempApi: '/api/cs/sg/presaleplan/getImportTemplate'
  },
  SKURELEASE__PS_C_SKU_RELEASE_MODIFY: {
    // 商品发布-修改商品信息
    isAsync: true,
    rowControl: true,
    isAction: true,
    tableName: 'SKURELEASE',
    webname: 'PS_C_SKU_RELEASE_MODIFY',
    okApi: '/api/cs/md/skuRelease/importCategory',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'psSkuReleaseCategoryImport'
    },
  },
  ST_C_CLIENT_SALE_PRO__ST_C_CLIENT_SALE_PRO_IMPORT: {
    // 客户可售商品清单-头明细导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    tableName: 'ST_C_CLIENT_SALE_PRO',
    webname: 'ST_C_CLIENT_SALE_PRO_IMPORT',
    okApi: '/api/cs/md/clientSalePro/MainSubImport',
    okParm: { flag: 'sell' },
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCClientSaleProImport'
    },
  },
  DC_B_RETURN_ORDER__return_order_item_import: {
    // 客户退货单-条码明细导入
    isAsync: true,
    rowControl: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'DC_B_RETURN_ORDER',
    webname: 'return_order_item_import',
    okApi: '/api/cs/dc/v1/returnOrder/import',
    okParm: { objid: null },
    tempMethod: 'get',
    tempApi: '/api/cs/dc/v1/returnOrder/getTemplateUrl',
  },
  ST_C_STORE_SETTING__Import_stCStoreSetting_Main: {
    isAsync: true,
    rowControl: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'ST_C_STORE_SETTING',
    webname: 'Import_stCStoreSetting_Main',
    okApi: '/api/cs/md/stCStoreSetting/import',
    okParm: { objid: null },
    tempMethod: 'get',
    tempApi: '/api/cs/md/stCStoreSetting/getImportTemplate',
  },
  ST_C_STORE_SETTING__IMPORTCOM: {
    isAsync: true,
    rowControl: true,
    isAction: true,
    isStandardSingleObject: true,
    tableName: 'ST_C_STORE_SETTING',
    webname: 'IMPORTCOM',
    okApi: '/api/cs/md/stCStoreSetting/import',
    okParm: { objid: null },
    tempMethod: 'get',
    tempApi: '/api/cs/md/stCStoreSetting/getImportTemplate',
  },
  ST_C_PRO_SOURCE_STRATEGY__PROSOURCESTRATEGYSTOREIMPORT: {
    // TOB商品寻源-导入
    isAsync: false,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'ST_C_PRO_SOURCE_STRATEGY',
    webname: 'PROSOURCESTRATEGYSTOREIMPORT',
    okApi: '/api/cs/md/StCProSourceStrategyCtrl/importStore',
    isStandardSingleObject: true,
    prefix: 'SYSTEM',
    okParm: { objid: null },
    tempMethod: 'get',
    tempApi: '/api/cs/md/StCProSourceStrategyCtrl/getTemplateUrl',
    downErrorInfo: true,
  },
  "ORDERMANAGER_TB__import-order": {
    // 客户订单-导入（全定制页面
    isAction: false,
    isAsync: true,
    tempMethod: 'get',
    tempApi: '/p/cs/downloadImportTemplate',
    tempParm: {
      searchdata: { table: 'DC_B_ORDER' }
    },
    okApi: '/p/cs/import',
    okParm: {
      table: 'DC_B_ORDER',
      mainId: 249231769,
      menu: '客户订单'
    },
  },
  ORDERMANAGER_TB__DC_B_ORDER_IMPORT: {
    // 客户订单-头明细导入（全定制页面
    isAction: false,
    isAsync: true,
    rowControl: true,
    okApi: '/api/cs/dc/v1/order/batchImport',
    tempApi: '/api/cs/dc/v1/order/downloadImportTemplate',
  },
  SG_B_DISTRIBUTION_RETURN_SELL__SG_B_DISTRIBUTION_RETURN_SELL_BATCH_IMPORT: {
    // 经销退货单-批量导入
    isAsync: true,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_DISTRIBUTION_RETURN_SELL',
    webname: 'SG_B_DISTRIBUTION_RETURN_SELL_BATCH_IMPORT',
    okApi: '/api/cs/sg/importDistributionReturn',
    okParm: { flag: 'sell' },
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBDistributionReturnSellImport'
    },
    downErrorInfo: true,
  },
  SG_B_DISTRIBUTION_RETURN_DIS__SG_B_DISTRIBUTION_RETURN_DIS_BATCH_IMPORT: {
    // 分销退货单-批量导入
    isAsync: true,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_DISTRIBUTION_RETURN_DIS',
    webname: 'SG_B_DISTRIBUTION_RETURN_DIS_BATCH_IMPORT',
    okApi: '/api/cs/sg/importDistributionReturn',
    okParm: { flag: 'dis' },
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBDistributionReturnDisImport'
    },
    downErrorInfo: true,
  },
  SG_B_DISTRIBUTION_RETURN_CONS__SG_B_DISTRIBUTION_RETURN_CONS_BATCH_IMPORT: {
    // 代销退货单-导入
    isAsync: true,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_DISTRIBUTION_RETURN_CONS',
    webname: 'SG_B_DISTRIBUTION_RETURN_CONS_BATCH_IMPORT',
    okApi: '/api/cs/sg/importDistributionReturnCons',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBDistributionReturnConsImport'
    },
    downErrorInfo: true,
  },
  // 代销订单导入
  OC_B_2_B_ORDER_DX__OC_B_2_B_ORDER_DX_IMPORT: {
    isAsync: true,
    rowControl: true,
    isErr1Succ1: true,
    downErrorInfo: true,
    tempMethod: 'get',
    tableName: 'OC_B_2_B_ORDER_DX',
    webname: 'OC_B_2_B_ORDER_DX_IMPORT',
    isAction: true,
    okApi: '/api/cs/ic/v1.0/oms/dxBatchImport/import',
    tempApi: '/api/cs/ic/v1.0/oms/dxBatchImport/template/url',
  },
  SG_B_CONSIGNMENT_INVENTORY_BILL__SG_B_CONSIGNMENT_INVENTORY_BILL_BATCH_IMPORT: {
    // 代销出入库账单-导入
    isAsync: true,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_CONSIGNMENT_INVENTORY_BILL',
    webname: 'SG_B_CONSIGNMENT_INVENTORY_BILL_BATCH_IMPORT',
    okApi: '/api/cs/sg/importConsignmentInventoryBill',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBConsignmentInventoryBillImport'
    },
    downErrorInfo: true,
  },
  PS_C_CATEGORY__PS_C_CATEGORY_IMPORT: {
    // 商品品类-导入
    isAsync: false,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'PS_C_CATEGORY',
    webname: 'PS_C_CATEGORY_IMPORT',
    okApi: '/api/cs/md/psCCategory/import',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'psCCategoryImport'
    },
    downErrorInfo: true,
  },
  SG_B_CHANNEL_TRANSFER__SG_B_CHANNEL_TRANSFER_BATCH_IMPORT: {
    // 渠道调拨单-批量导入
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_CHANNEL_TRANSFER',
    webname: 'SG_B_CHANNEL_TRANSFER_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBChannelTransfer/batchImport',
    tempApi: '/api/cs/sg/sgBChannelTransfer/downloadImportTemplate',
    downErrorInfo: true,
  },
  SG_B_SHARE_ALLOCATION__SG_B_SHARE_ALLOCATION_BATCH_IMPORT: {
    // 分货单-批量导入
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_SHARE_ALLOCATION',
    webname: 'SG_B_SHARE_ALLOCATION_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBShareAllocation/batchImport',
    tempApi: '/api/cs/sg/sgBShareAllocation/downloadImportTemplate',
    downErrorInfo: true,
  },
  SG_B_SHARE_SA_TRANSFER__SG_B_SHARE_SA_TRANSFER_BATCH_IMPORT: {
    // 配销仓调拨单-批量导入
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_SHARE_SA_TRANSFER',
    webname: 'SG_B_SHARE_SA_TRANSFER_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBShareSaTransfer/batchImport',
    tempApi: '/api/cs/sg/sgBShareSaTransfer/downloadImportTemplate',
    downErrorInfo: true,
  },

  SG_B_SHARE_ALLOCATION_RETURN__SG_B_SHARE_ALLOCATION_RETURN_IMPORT: {
    // 分货退货单-批量导入
    isAsync: true,
    rowControl: false,
    isAction: true,
    tableName: 'SG_B_SHARE_ALLOCATION_RETURN',
    webname: 'SG_B_SHARE_ALLOCATION_RETURN_IMPORT',
    okApi: '/api/cs/sg/sgBShareAllocationReturn/batchImport',
    tempApi: '/api/cs/sg/sgBShareAllocationReturn/downloadImportTemplate',
    downErrorInfo: true,
  },
    SG_B_STO_DEPARTMENT_RETURN_OUT__SG_B_STO_DEPARTMENT_RETURN_OUT_IMPORT: {
    // 部门借用单-批量导入
    isAsync: true,
    rowControl: false,
    isAction: true,
    tableName: 'SG_B_STO_DEPARTMENT_RETURN_OUT',
    webname: 'SG_B_STO_DEPARTMENT_RETURN_OUT_IMPORT',
    okApi: '/api/cs/sg/deptBorrow/batchImport',
    tempApi: '/api/cs/sg/deptBorrow/downloadImportTemplate',
    downErrorInfo: true,
  },
  SG_B_STO_ADJUST__SG_B_STO_ADJUST_IMPORT_MIDDLE: {
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_STO_ADJUST',
    webname: 'SG_B_STO_ADJUST_IMPORT_MIDDLE',
    okApi: '/api/cs/sg/sgBStoAdjust/batchImport',
    tempApi: '/api/cs/sg/sgBStoAdjust/downloadImportTemplate',
    downErrorInfo: true,
  },
  SG_B_STO_TRANSFER__SG_B_STO_TRANSFER_BATCH_IMPORT: {
    // 逻辑调拨单-批量导入
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_STO_TRANSFER',
    webname: 'SG_B_STO_TRANSFER_BATCH_IMPORT',
    okApi: '/api/cs/sg/sgBStoTransfer/batchImport',
    tempApi: '/api/cs/sg/sgBStoTransfer/downloadImportTemplate',
    downErrorInfo: true,
  },
  // 门店配货计划明细导入
  SG_B_STO_STORE_DISTRIBUTION__SG_B_STO_STORE_DISTRIBUTION_ITEM_IMPORT: {
    isStandardSingleObject: true,
    prefix: 'SYSTEM',
    okParm: { id: null },
    isAsync: true,
    isAction: true,
    tableName: 'SG_B_STO_STORE_DISTRIBUTION',
    webname: 'SG_B_STO_STORE_DISTRIBUTION_ITEM_IMPORT',
    tempApi: '/api/cs/sg/storeDistributionItem/downloadImportTemplate',
    okApi: '/api/cs/sg/storeDistributionItem/batchImport',
    downErrorInfo: true,
  },
  SG_B_CHANNEL_PRODUCT__SG_B_CHANNEL_PRODUCT_IMPORT: {
    // 平台店铺商品-导入
    isAsync: true,
    rowControl: false,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_CHANNEL_PRODUCT',
    webname: 'SG_B_CHANNEL_PRODUCT_IMPORT',
    okApi: '/api/cs/sg/importSgChannelProduct',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'sgBChannelProductImport'
    },
    downErrorInfo: true,
  },
  V_SG_C_CHANNEL_RATIO_STRATEGY__RATIO_STRATEGY_IMPORT: {
    // 比例同步策略-导入
    isAsync: true,
    isAction: true,
    isErr1Succ1: true,
    tempMethod: 'get',
    tableName: 'V_SG_C_CHANNEL_RATIO_STRATEGY',
    webname: 'RATIO_STRATEGY_IMPORT',
    tempApi: '/api/cs/sg/sg_c_channel_ratio_strategy/templateUrl',
    okApi: '/api/cs/sg/sg_c_channel_ratio_strategy/import',
    downErrorInfo: true,
  },
  // OC_B_PRE_ORDER__pre_order_import: {
  //   // 零售发货单预导入-导入
  //   isAsync: true,
  //   rowControl: false,
  //   isErr1Succ1: true,
  //   isAction: true,
  //   tableName: 'OC_B_PRE_ORDER',
  //   webname: 'pre_order_import',
  //   okApi: '/api/cs/oc/oms/pre/v1/importOcBOrder',
  //   tempApi: '/api/cs/oc/oms/v1/downloadOrderTemp',
  //   downErrorInfo: true,
  // },
  AC_F_LOGISTICS_FEE_DIFF__LOGISTICS_FEE_DIFF_IMPORT: {
    // 物流费用差异处理-头明细导入
    isAsync: false,
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'AC_F_LOGISTICS_FEE_DIFF',
    webname: 'LOGISTICS_FEE_DIFF_IMPORT',
    okApi: '/api/cs/ac/importLogisticsFeeDiff',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'acFLogisticsFeeDiffImport'
    },
    downErrorInfo: true,
  },
  SG_B_PHY_PROFIT__SG_B_PHY_PROFIT_IMPORT: {
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'SG_B_PHY_PROFIT',
    webname: 'SG_B_PHY_PROFIT_IMPORT',
    okApi: '/api/cs/sg/v2/sgBPhyProfit/import',
    tempApi: '/api/cs/sg/v2/sgBPhyProfit/template/url',
    tempMethod: 'get',
    downErrorInfo: true,
  },
  ST_C_EXPIRY_DATE__ST_C_EXPIRY_DATE_IMPORT: {
    // 商品效期策略-头明细导入
    rowControl: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'ST_C_EXPIRY_DATE',
    webname: 'ST_C_EXPIRY_DATE_IMPORT',
    okApi: '/api/cs/oc/oms/stExpiryDateStrategy/import',
    tempApi: '/api/cs/oc/oms/stExpiryDateStrategy/template/url',
    tempMethod: 'get',
    downErrorInfo: true,
  },
  ST_C_EXPRESS_COST__EXPRESS_COST_IMPORT: {
    // 快运报价-导入
    rowControl: true,
    isAsync: true,
    isErr1Succ1: true,
    isAction: true,
    tableName: 'ST_C_EXPRESS_COST',
    webname: 'EXPRESS_COST_IMPORT',
    okApi: '/api/cs/oc/oms/importExpressCost',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCExpressCostImport'
    },
    downErrorInfo: true,
  },
  ST_C_SHOP_LOGISTIC_STRATEGY__ST_SHOP_LOGISTICS_IMPORT: {
    // 店铺物流设置-导入
    rowControl: true,
    isAsync: true,
    isErr1Succ1: true, // 下载错误信息,code != -1,否则会直接被框架拦截
    isAction: true,
    tableName: 'ST_C_SHOP_LOGISTIC_STRATEGY',
    webname: 'ST_SHOP_LOGISTICS_IMPORT',
    okApi: '/api/cs/md/shopLogisticStrategy/import',
    tempApi: '/api/cs/md/shopLogisticStrategy/template/url',
    tempMethod: 'get',
    downErrorInfo: true,
  },
  ST_C_WAREHOUSE_LOGISTIC_STRATEGY__ST_WAREHOUSE_LOGISTICS_IMPORT: {
    // 仓库物流设置-导入
    rowControl: true,
    isAsync: true,
    isErr1Succ1: true, // 下载错误信息,code != -1,否则会直接被框架拦截
    isAction: true,
    tableName: 'ST_C_WAREHOUSE_LOGISTIC_STRATEGY',
    webname: 'ST_WAREHOUSE_LOGISTICS_IMPORT',
    okApi: '/api/cs/md/warehouseLogisticStrategy/import',
    tempApi: '/api/cs/md/warehouseLogisticStrategy/template/url',
    tempMethod: 'get',
    downErrorInfo: true,
  },
  ST_C_EXPRESS_PRICE_STRATEGY__EXPRESS_PRICE_IMPORT: {
    // 快递报价设置-导入
    rowControl: true,
    isAsync: false,
    isErr1Succ1: true, // 下载错误信息,code != -1,否则会直接被框架拦截
    isAction: true,
    tableName: 'ST_C_EXPRESS_PRICE_STRATEGY',
    webname: 'EXPRESS_PRICE_IMPORT',
    okApi: '/api/cs/oc/oms/importExpressPrice',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCExpressPriceStrategyImport'
    },
    downErrorInfo: true,
  },
  ST_C_UNFULLCAR_COST__UNFULLCAR_COST_IMPORT: {
    // 零担费用设置-导入
    rowControl: true,
    isAsync: false,
    isErr1Succ1: true, // 下载错误信息,code != -1,否则会直接被框架拦截
    isAction: true,
    tableName: 'ST_C_UNFULLCAR_COST',
    webname: 'UNFULLCAR_COST_IMPORT',
    okApi: '/api/cs/md/importSyncUnfullcarCost',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'stCUnfullcarCostImport'
    },
    downErrorInfo: true
  },
  OC_B_REFUND_IN__refundInImport: {
    tableName: 'OC_B_REFUND_IN',
    webname: 'PURCHASE_IMPORT',
    okApi: '/api/cs/oc/oms/v1/refundInImport',
    tempApi: '/api/cs/oc/oms/v1/downloadRdfundInRemarkTemp',
    downErrorInfo: true
  },
  OC_B_REFUND_IN__headless_import: {
    isAsync: true,
    tableName: 'OC_B_REFUND_IN',
    webname: 'headless_import',
    okApi: '/api/cs/oc/oms/v1/importOcBRefundIn',
    tempApi: '/api/cs/oc/oms/v1/downloadimportOcBRefundInTemp',
  },
  OC_B_REFUND_IN__batch_Import: {
    isAsync: true,
    tableName: 'OC_B_REFUND_IN',
    webname: 'batch_Import',
    okApi: '/api/cs/oc/oms/v1/ocBRefundIn/batchImport',
    tempApi: '/api/cs/oc/oms/v1/downloadBatchImportOcBRefundInTemp',
  },
  // 丢件单导入
  AC_F_PAYABLE_ADJUSTMENT__payableAdjustmentImport: {

    tableName: 'AC_F_PAYABLE_ADJUSTMENT',
    webname: 'payableAdjustmentImport',
    okApi: '/api/cs/oc/oms/importPayableAdjustment',
    tempApi: '/api/cs/oc/oms/downloadPayableAdjustment',
    downErrorInfo: true
  },
  // 退货入库-导入
  OC_B_PURCHASE__PURCHASE_IMPORT: {
    // 采购单-导入
    isAction: true,
    tableName: 'OC_B_PURCHASE',
    webname: 'PURCHASE_IMPORT',
    tempApi: '/p/cs/oc/oms/v1/purchase/templateDownLoad',
    okApi: '/p/cs/oc/oms/v1/purchase/import',
    downErrorInfo: true
  },
  SG_B_GOOD_DISTRIBUTION__SG_B_GOOD_DISTRIBUTION_ITEM_IMPORT: {
    // 分货单单对象-导入
    isAction: true,
    tableName: 'SG_B_GOOD_DISTRIBUTION',
    webname: 'SG_B_GOOD_DISTRIBUTION_ITEM_IMPORT',
    tempApi: '/api/cs/sg/v1/sgBGoodDistribution/exportTemplate',
    okApi: '/api/cs/sg/v1/sgBGoodDistribution/itemImport',
    // okParm: { id: R3.store.state.customize._this.$route.params.itemId },
    isStandardSingleObject: true,
    prefix: 'SYSTEM',
    dontRefreshTable: false,
    okParm: { id: null },
    downErrorInfo: true
  },
  SG_B_GOOD_DISTRIBUTION__SG_B_GOOD_DISTRIBUTION_IMPORT: {
    // 分货单-导入
    isAction: true,
    tableName: 'SG_B_GOOD_DISTRIBUTION',
    webname: 'SG_B_GOOD_DISTRIBUTION_ITEM_IMPORT',
    tempApi: '/api/cs/sg/v1/sgBGoodDistribution/exportTemplate',
    okApi: '/api/cs/sg/v1/sgBGoodDistribution/import',
    prefix: 'SYSTEM',
    dontRefreshTable: false,
    downErrorInfo: true
  },
  PS_C_PRO_CLASSIFY__ps_c_pro_classify_import: {
    // 商品分类-导入
    isAction: true,
    tableName: 'PS_C_PRO_CLASSIFY',
    webname: 'ps_c_pro_classify_import',
    tempApi: '/p/cs/md/pro/classify/v1/classSku/template',
    okApi: '/p/cs/md/pro/classify/v1/classSku/import',
    downErrorInfo: true
  },
  V_CP_C_REGION_ALIAS__regionImport: {
    // 国家省市区-导入
    isAction: true,
    tableName: 'V_CP_C_REGION_ALIAS',
    webname: 'regionImport',
    tempApi: '/p/cs/md/import/v1/region/template',
    okApi: '/p/cs/md/import/v1/region/import',
    downErrorInfo: true
  },
  ST_C_SHOP_STRATEGY__shopStrategyImport: {
    // 店铺策略导入
    isAction: true,
    tableName: 'ST_C_SHOP_STRATEGY',
    webname: 'shopStrategyImport',
    tempApi: '/p/cs/md/v1/shopStrategy/downLoad',
    okApi: '/p/cs/md/v1/shopStrategy/import',
    downErrorInfo: true
  },
  ST_C_SYNC_STOCK_STRATEGY__syncStockStrategyImport: {
    // 店铺策略导入
    isAction: true,
    tableName: 'ST_C_SYNC_STOCK_STRATEGY',
    webname: 'syncStockStrategyImport',
    tempApi: '/p/cs/md/v1/syncStockStrategy/downLoadSyncStockStrategyImportTemp',
    okApi: '/p/cs/md/v1/syncStockStrategy/importSyncStockStrategy',
    downErrorInfo: true
  },
  AC_F_ALIPAY_ACCOUNTMANAGE__zfbAccountImport: {
    // 额外退款单-导入打款结果
    isAction: true,
    tableName: 'AC_F_ALIPAY_ACCOUNTMANAGE',
    webname: 'zfbAccountImport',
    tempApi: '/p/cs/ac/v1/alipayAccountManage/exportTemplate',
    okApi: '/p/cs/ac/v1/alipayAccountManage/importData',
    downErrorInfo: true,
  },
  OC_B_REFUND_ORDER_EXTRA__IMPORT_PAY_RESULT: {
    // 额外退款单-导入打款结果
    isAction: true,
    tableName: 'OC_B_REFUND_ORDER_EXTRA',
    webname: 'IMPORT_PAY_RESULT',
    tempApi: '/p/cs/oc/oms/v1/refundExtra/remitResultDownLoad',
    okApi: '/p/cs/oc/oms/v1/refundExtra/remitResultImport',
    downErrorInfo: true,
    isErr1Succ1: true
  },
  OC_B_RETURN_AF_SEND_MANUAL__导入打款结果: {
    // 额外退款单-导入打款结果
    isAction: true,
    tableName: 'OC_B_RETURN_AF_SEND_MANUAL',
    webname: '导入打款结果',
    tempApi: '/api/cs/oc/oms/v1/downloadUpdateOcBReturnAfSendTemp',
    okApi: '/api/cs/oc/oms/v1/batchUpdateOcBReturnAfSend',
    downErrorInfo: true,
    isErr1Succ1: true
  },
  OC_B_RETURN_AF_RECEIPT__audit_Import: {
    isAction: true,
    tableName: 'OC_B_RETURN_AF_RECEIPT',
    webname: 'audit_Import',
    tempApi: '/api/cs/oc/oms/v1/downloadReturnAfReceiptAuditTemp',
    okApi: '/api/cs/oc/oms/v1/importReturnAfReceiptAudit',
    downErrorInfo: true,
    isErr1Succ1: true
  },
  OC_B_RETURN_AF_RECEIPT__div_Import: {
    isAction: true,
    tableName: 'OC_B_RETURN_AF_RECEIPT',
    webname: 'div_Import',
    tempApi: '/api/cs/oc/oms/v1/downloadReturnAfReceiptTemp',
    okApi: '/api/cs/oc/oms/v1/importReturnAfReceipt',
    downErrorInfo: true,
    isErr1Succ1: true
  },
  OC_B_REFUND_ORDER_EXTRA__EXTRA_IMPORT: {
    // 额外退款单-导入
    isAction: true,
    tableName: 'OC_B_REFUND_ORDER_EXTRA',
    webname: 'EXTRA_IMPORT',
    tempApi: '/p/cs/oc/oms/v1/refundExtra/downLoad',
    okApi: '/p/cs/oc/oms/v1/refundExtra/import',
    downErrorInfo: true,
  },
  OC_B_RETURN_AF_SEND_MANUAL__自定义导入: {
    // 额外退款单-导入
    isAction: true,
    tableName: 'OC_B_RETURN_AF_SEND_MANUAL',
    webname: '自定义导入',
    tempApi: '/api/cs/oc/oms/v1/downloadReturnAfSendTemp',
    okApi: '/api/cs/oc/oms/v1/importReturnAfSend',
    downErrorInfo: true,
  },
  CP_C_PHY_WAREHOUSE__warehouseImport: {
    isAction: true,
    tableName: 'CP_C_PHY_WAREHOUSE',
    webname: 'warehouseImport',
    tempApi: '/p/cs/md/import/v1/warehouse/template',
    tempParm: null,
    okApi: '/p/cs/md/import/v1/warehouse/import',
    okParm: null,
    downErrorInfo: true,
  },
  CP_C_LOGISTICS__logisticsImport: {
    // 物流公司档案-导入
    isAction: true,
    tableName: 'CP_C_LOGISTICS',
    webname: 'logisticsImport',
    tempApi: '/p/cs/md/import/v1/logistics/template',
    tempParm: null,
    okApi: '/p/cs/md/import/v1/logistics/import',
    okParm: null,
    downErrorInfo: true,
  },
  PS_C_SKU__skuImportUpdate: {
    // 商品sku-导入更新
    isAction: true,
    tableName: 'PS_C_SKU',
    webname: 'skuImportUpdate',
    tempApi: '/p/cs/md/import/v1/sku/template',
    tempParm: null,
    okApi: '/p/cs/md/import/v1/sku/update',
    okParm: null,
    downErrorInfo: true,
    showErrorInfo: false,
    // freshPage: Fn,
    importNotes: false,
    dontShowDownloadA: false,
  },
  PS_C_SKU__skuImport: {
    // 商品sku-导入
    isAction: true,
    tableName: 'PS_C_SKU',
    webname: 'skuImport',
    tempApi: '/p/cs/md/import/v1/template',
    okApi: '/p/cs/md/import/v1/pro',
    downErrorInfo: true,
  },
  PS_C_PRO__spuImportUpdate: {
    // 商品spu-导入更新
    isAction: true,
    tableName: 'PS_C_PRO',
    webname: 'spuImportUpdate',
    tempApi: '/p/cs/md/import/v1/spu/template',
    okApi: '/p/cs/md/import/v1/pro/update',
    downErrorInfo: true,
  },
  PS_C_PRO__spuImport: {
    // 商品spu-导入
    isAction: true,
    tableName: 'PS_C_SKU',
    webname: 'skuImport',
    tempApi: '/p/cs/md/import/v1/template',
    okApi: '/p/cs/md/import/v1/pro',
    downErrorInfo: true,
  },
  // 主数据组合商品导入
  PS_C_PRO_GROUP__PS_C_PRO_GROUP__IMPORT: {
    isAction: true,
    tableName: 'PS_C_PRO_GROUP',
    webname: 'PS_C_PRO_GROUP__IMPORT',
    okApi: '/api/cs/md/product/proGroupImport',
    tempApi: '/api/cs/md/download/customizationTemplate',
    tempParm: {
      actionName: 'proGroupImport'
    },
    downErrorInfo: true,
    // dontShowDownloadA:true,


  },
  PS_C_PRO_GROUP__PROGROUPLISTIMPORT: {
    isAction: true,
    tableName: 'PS_C_PRO_GROUP',
    webname: 'ordinaryGroupImport',
    tempUrl: 'https://bj-ib-upload.oss-cn-shanghai.aliyuncs.com/import/template/893/%E7%BB%84%E5%90%88%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx',
    okApi: '/p/cs/md/import/v1/group',
    downErrorInfo: true,
  },
  PS_C_PRO_GROUP__ordinaryGroupImport: {
    // 普通组合商品导入-普通商品导入
    isAction: true,
    tableName: 'PS_C_PRO_GROUP',
    webname: 'ordinaryGroupImport',
    tempApi: '/p/cs/md/import/v1/groupSku/template',
    okApi: '/p/cs/md/import/v1/group',
    downErrorInfo: true,
  },
  PS_C_PRO_GROUP__luckGroupImport: {
    // 普通组合商品导入-福袋商品导入
    isAction: true,
    tableName: 'PS_C_PRO_GROUP',
    webname: 'luckGroupImport',
    tempApi: '/p/cs/md/import/v1/luckySku/template',
    okApi: '/p/cs/md/import/v1/luckygroup',
    downErrorInfo: true,
  },
  OC_B_ORDER: {
    tableName: 'OC_B_ORDER',
    okApi: '/api/cs/oc/oms/v1/importOcBOrder',
    tempApi: '/api/cs/oc/oms/v1/downloadOrderTemp'
  }, // 零售发货单 - 正常订单导入
  OC_B_ORDER2: {
    tableName: 'OC_B_ORDER2',
    okApi: '/api/cs/oc/oms/v1/importGiftOcBOrder',
    tempApi: '/api/cs/oc/oms/v1/downloadOrderTemp'
  }, // 退换货 - 退换货单批量导入
  RETURN_OC_B_ORDER: {
    tableName: 'RETURN_OC_B_ORDER',
    okApi: '/api/cs/oc/oms/v2/importReturnOrder',
    tempApi: '/api/cs/oc/oms/v2/downloadReturnOrderTemp'
  },
  PS_C_SKU: {
    tableName: 'PS_C_SKU',
    okApi: '/api/cs/onlinepm/v1/parseExcel',
    // 促销批量
    urlType: '/api/cs/onlinepm/v1/parseActiExcelCmd',
    tempApi: '/api/cs/onlinepm/v1/getModuleUrl'
  },
  SG_B_CHANNEL_PRODUCT: {
    tableName: 'SG_B_CHANNEL_PRODUCT',
    okApi: '/api/cs/onlinepm/v1/parseExcel',
    // 促销批量
    urlType: '/api/cs/onlinepm/v1/parseActiExcelCmd',
    tempApi: '/api/cs/onlinepm/v1/getModuleUrl'
  },
  PS_C_PRO: {
    tableName: 'PS_C_PRO',
    okApi: '/api/cs/onlinepm/v1/parseExcel',
    // 促销批量
    urlType: '/api/cs/onlinepm/v1/parseActiExcelCmd',
    tempApi: '/api/cs/onlinepm/v1/getModuleUrl'
  },
  IP_C_TAOBAO_PRODUCT: {
    tableName: 'IP_C_TAOBAO_PRODUCT',
    okApi: '/api/cs/onlinepm/v1/parseExcel',
    // 促销批量
    urlType: '/api/cs/onlinepm/v1/parseActiExcelCmd',
    tempApi: '/api/cs/onlinepm/v1/getModuleUrl'
  },
  OC_B_RETURN_ORDER: {
    tableName: 'OC_B_RETURN_ORDER',
    tempApi: '/api/cs/oc/oms/v1/downloadReturnOrderTemp'
  }, // 退换货订单
  PS_C_SKUGROUP: {
    tableName: 'PS_C_SKUGROUP',
    // 组合商品档案明细与虚拟条码
    okApi: '/api/cs/md/product/realSkuGroupImport',
    // 组合商品档案明细
    urlType: '/api/cs/md/product/skuGroupImport',
    // 组合商品档案明细与虚拟条码
    tempApi: '/api/cs/md/product/downloadRealSkuGroupTemp',
    // 组合商品档案明细
    downloadUrlType: '/api/cs/md/product/downloadSkuGroupTemp'
  },
  OC_B_INVOICE_NOTICE: {
    tableName: 'OC_B_INVOICE_NOTICE',
    okApi: '/api/cs/oc/oms/v1/importInvoiceNotice',
    tempApi: '/api/cs/oc/oms/v1/downloadInvoiceNotice'
  }, // 开票信息
  OC_B_RETURN_AF_SEND_MANUAL: {
    tableName: 'OC_B_RETURN_AF_SEND_MANUAL',
    okApi: '/api/cs/oc/oms/v1/downloadUpdateOcBReturnAfSendTemp',
    tempApi: '/api/cs/oc/oms/v1/batchUpdateOcBReturnAfSend'
  }, // 打款结果
  POS_SC_B_TRANSFER: {
    tableName: 'POS_SC_B_TRANSFER',
    okApi: '/api/cs/sg/transferPos/import',
  },
  OC_B_SALE: {
    tableName: 'OC_B_SALE',
    okApi: '/p/cs/oc/sale/pdaImport',
  },
  OC_B_REFUND_SALE: {
    tableName: 'OC_B_REFUND_SALE',
    okApi: '/p/cs/oc/refundSale/pdaImport',
  },
  SG_B_OUT_PICKORDER: {
    tableName: 'SG_B_OUT_PICKORDER',
    okApi: '/api/cs/sg/outPickorder/pdaImport',
  },
  OC_B_JD_REFUND_IN: {
    tableName: 'OC_B_JD_REFUND_IN',
    okApi: '/p/cs/ocBJdRefundInOrder/importTemple',
  },
  AC_F_DISTRIBUTION: {
    tableName: 'AC_F_DISTRIBUTION',
    okApi: '/p/cs/importDistributionItem',
    tempApi: '/p/cs/downloadDistributionItem'
  }, // 分销代销商品明细
  /* ST_C_EXPRESS_AREA: {
    tableName: 'ST_C_EXPRESS_AREA',
    okApi: '/api/cs/md/importExpressAreaItem',
    tempApi: '/api/cs/md/downloadExpressAreaItem'
  }, // 物流区域设置 */
  OUT_OF_STOCK_MEMO: {
    tableName: 'OUT_OF_STOCK_MEMO',
    okApi: '/api/cs/oc/oms/v1/batchImport',
    tempApi: '/api/cs/oc/oms/v1/downloadUpdateRemarkTemp'
  }, // 缺货备注
  ST_C_WAREHOUSE_LOGISTICS: {
    tableName: 'ST_C_WAREHOUSE_LOGISTICS',
    okApi: '/p/cs/importWarehouseLogisticsRank',
    tempApi: '/p/cs/downloadWarehouseLogisticsRank'
  }, // 仓库物流优先级设置
  OC_B_REFUND_IN: {
    tableName: 'OC_B_REFUND_IN',
    okApi: '/api/cs/oc/oms/v1/refundInImport',
    tempApi: '/api/cs/oc/oms/v1/downloadRdfundInRemarkTemp'
  }, // 退货入库
  ST_C_SEND_RULE: {
    tableName: 'ST_C_SEND_RULE',
    okApi: '/p/cs/importSendRuleWarehouseRank',
    tempApi: '/p/cs/downloadSendRuleWarehouseRank'
  }, // 订单派单规则-优先级
  ST_C_SEND_RULE_RATE: {
    tableName: 'ST_C_SEND_RULE_RATE',
    okApi: '/p/cs/importSendRuleWarehouseRate',
    tempApi: '/p/cs/downloadSendRuleWarehouseRate'
  }, // 订单派单规则-比例
  OC_B_RETURN_ORDER_remark: {
    importNotes: true,
    tableName: 'OC_B_RETURN_ORDER_remark',
    okApi: '/api/cs/oc/oms/v1/importReturnSellerRemark',
    tempApi: '/api/cs/oc/oms/v1/downloadReturnRemarkTemp'
  }, // 退换货卖家备注导入
  AC_F_RECEIVABLES_ADJUSTMENT: {
    tableName: 'AC_F_RECEIVABLES_ADJUSTMENT',
    okApi: '/p/cs/receivableAdjustmentImport',
    tempApi: '/p/cs/receivableAdjustmentDownload'
  }, // 应收款调整单导入
  SC_B_TRANSFER: {
    tableName: 'SC_B_TRANSFER',
    okApi: '/p/cs/transfer/sgTransferImport',
    urlType: '/p/cs/store/transfer/importTransferItems',
    tempApi: '/p/cs/transfer/downloadTemp',
    downloadUrlType: 'http://qd-r3-upload-dev.oss-cn-shanghai.aliyuncs.com/import/template/sc_b_transfer/dbd_template.xlsx'
  }, //
  SG_B_PHY_OUT_RESULT: {
    tableName: 'SG_B_PHY_OUT_RESULT',
    okApi: '/p/cs/importSgPhyOutResult',
    tempApi: '/p/cs/downLoadSgPhyOutResultTemp'
  }, // 出库结果单
  OC_B_MULTI_STORE_DISTRIBUTION: {
    tableName: 'OC_B_MULTI_STORE_DISTRIBUTION',
    okApi: '/p/cs/oc/v1/sale/importMultiStoreDistributionSku',
    tempApi: '/p/cs/oc/v1/sale/downloadMultiStoreDistributionSku'
  }, //
  OC_B_SEND_OUT: {
    tableName: 'OC_B_SEND_OUT',
    okApi: '/p/cs/oc/v1/send/importSendOutSku',
    urlType: '/p/cs/oc/v1/send/importSendOut',
    tempApi: 'http://qd-r3-upload-dev.oss-cn-shanghai.aliyuncs.com/import/template/saleorder/importTemplate.xlsx',
    downloadUrlType: 'http://qd-r3-upload-dev.oss-cn-shanghai.aliyuncs.com/import/template/saleorder/importTemplate_batch.xlsx'
  },
  OC_B_JD_RETURN_ORDER: {
    tableName: 'OC_B_JD_RETURN_ORDER',
    okApi: '/p/cs/ocBJdReturnOrder/importTemple',
    tempApi: '/p/cs/ocBJdReturnOrder/downloadTemple'
  },
  IP_C_STANDPLAT_PRO: {
    tableName: 'IP_C_STANDPLAT_PRO',
    okApi: '/api/cs/ip/getItemIdsForExcel',
    tempUrl: 'http://smtools.oss-cn-shanghai.aliyuncs.com/import/template/893/商品下载-商品代码上传模板-root-20200622161110098.xlsx'
  }, // 通用商品下载
  ST_C_SYNC_STOCK_STRATEGY: {
    tableName: 'ST_C_SYNC_STOCK_STRATEGY',
    okApi: '/p/cs/importSyncStockStrategy',
    tempApi: '/p/cs/downLoadSyncStockStrategyImportTemp'
  }, // 店铺同步库存策略
  ST_C_PRODUCT_STRATEGY: {
    tableName: 'ST_C_PRODUCT_STRATEGY',
    okApi: '/p/cs/productStrategy/import/multiShopItem',
    tempApi: '/p/cs/productStrategy/import/downloadMultiShopTemp'
  }, // 店铺商品特殊设置 - 多店铺比例-明细导入


};
export default importConfig;
